export { timeAgo } from 'components/atoms/ProjectLogEntryStream/utils';

export const sortByDate = (a?: string, b?: string) => {
  const timeA = a ? Date.parse(a) : NaN;
  const timeB = b ? Date.parse(b) : NaN;

  const validA = !isNaN(timeA);
  const validB = !isNaN(timeB);

  if (!validA && !validB) {
    return 0;
  }
  if (!validA) {
    return 1;
  }
  if (!validB) {
    return -1;
  }
  return timeB - timeA;
};
